import React, {  useMemo, useState } from "react";
import { useLocation, useParams } from "react-router-dom";
import { api } from "../../../app/Api/ApiSlice";
import { toast } from "react-toastify";
import "../storesStyles.css";

const StoreInvoice = () => {
  const { name, id } = useParams();

  // const [invoice, setInvoice] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const location = useLocation()

  const { invoice } = location.state

  /* ========================
     Calculations (standard)
  ======================== */
  const subtotal = useMemo(() => {
    if (!invoice?.items) return 0;
    return invoice.items.reduce(
      (acc, item) => acc + item.price * item.quantity,
      0
    );
  }, [invoice]);

  const tax = invoice?.tax || 0;
  const discount = invoice?.discount || 0;
  const grandTotal = subtotal + tax - discount;

  /* ========================
     Actions
  ======================== */
  const markPaid = async () => {
    try {
      setIsLoading(true);
      await api.post(
        `/stores/${name}/invoices/${invoice._id}/paid`
      );
      invoice(prev => ({ ...prev, isPaid: true }));
      toast.success("Invoice marked as paid");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed");
    } finally {
      setIsLoading(false);
    }
  };

  const markDelivered = async () => {
    try {
      setIsLoading(true);
      await api.post(
        `/stores/${name}/orders/${invoice.order}/delivered`
      );
      toast.success("Order marked as delivered");
    } catch (error) {
      toast.error(error?.response?.data?.message || "Failed");
    } finally {
      setIsLoading(false);
    }
  };

  if (isLoading) return <p>Loading invoice...</p>;
  if (!invoice) return <p className="not-found-msg">Invoice not found</p>;

  return (
    <div className="store-orders-container">
      <h2 className="page-title">Invoice</h2>

      {/* ========================
         Invoice Summary
      ======================== */}
      <div className="order-details">
        <div className="order-details-info">
          <strong>Invoice No:</strong>
          <span>{invoice.invoiceNo}</span>
        </div>

        <div className="order-details-info">
          <strong>Status:</strong>
          <span
            className={`order-status ${invoice.isPaid ? "Paid" : "Pending"
              }`}
          >
            {invoice.isPaid ? "Paid" : "Due"}
          </span>
        </div>

        <div className="order-details-info">
          <strong>Order ID:</strong>
          <span>{invoice.order}</span>
        </div>

        <div className="order-details-info">
          <strong>Issued On:</strong>
          <span>
            {new Date(invoice.createdAt).toLocaleDateString()}
          </span>
        </div>

        {invoice.dueDate && !invoice.isPaid && (
          <div className="order-details-info">
            <strong>Due Date:</strong>
            <span>
              {new Date(invoice.dueDate).toLocaleDateString()}
            </span>
          </div>
        )}
      </div>

      {/* ========================
         Seller Info
      ======================== */}
      <div className="order-details">
        <div className="order-details-info">
          <strong>Seller:</strong>
          <span>{invoice.store?.name}</span>
        </div>

        <div className="order-details-info">
          <strong>Email:</strong>
          <span>{invoice.store?.contacts?.email}</span>
        </div>

        <div className="order-details-info">
          <strong>Phone:</strong>
          <span>{invoice.store?.contacts?.phone}</span>
        </div>
      </div>

      {/* ========================
         Items Table
      ======================== */}
      <div className="table-wrapper">
        <table className="orders-table">
          <thead>
            <tr>
              <th>Item</th>
              <th>Price</th>
              <th>Qty</th>
              <th>Subtotal</th>
            </tr>
          </thead>
          <tbody>
            {invoice.items.map(item => (
              <tr key={item._id}>
                <td>{item.name}</td>
                <td>KES {item.price}</td>
                <td>{item.quantity}</td>
                <td className="order-total">
                  KES {item.price * item.quantity}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* ========================
         Price Breakdown
      ======================== */}
      <div className="price-breakdown">
        <div className="price-row">
          <span>Subtotal</span>
          <span>KES {subtotal}</span>
        </div>

        <div className="price-row">
          <span>Tax</span>
          <span>KES {tax}</span>
        </div>

        {discount > 0 && (
          <div className="price-row discount">
            <span>Discount</span>
            <span>- KES {discount}</span>
          </div>
        )}

        <div className="price-row grand-total">
          <strong>Total</strong>
          <strong>KES {grandTotal}</strong>
        </div>
      </div>

      {/* ========================
         Actions
      ======================== */}
      <div className="order-actions">
        {!invoice.isPaid && (
          <button
            className="btn-primary"
            onClick={markPaid}
            disabled={isLoading}
          >
            Mark as Paid
          </button>
        )}

        <button
          className="btn-secondary"
          onClick={markDelivered}
        >
          Mark Delivered
        </button>

        <button
          className="btn-secondary"
          onClick={() => window.print()}
        >
          Download / Print
        </button>
      </div>
    </div>
  );
};

export default StoreInvoice;
